import React from 'react';

export function ExerciseType(props) {
    let fsize = "sg-time p-1";
    if(props.edit_template === "true")
    {
        fsize="preview_sgtime px-1";
    }
    return (
        <span className={`${fsize} margin-0`}>{props.title}</span>
    )


}